import { Vue } from 'vue-property-decorator';
import i18n from '../i18n';

export default class ModalService extends Vue {
    relative = '90%';

    fixed = '600px';

    constructor(props: any = {}) {
        super({ ...props, i18n });
    }

    get modalWidth(): string {
        return window.innerWidth < 600 ? this.relative : this.fixed;
    }

    public showNeedProfileUpdateModal() {
        this.showModal(`
                      <div class="p-4">
                        <div class="p-4 mb-6 flex justify-center items-center">
                            {{ this.$t('modals.profile_update.complete') }}
                        </div>
                        <div class="flex justify-center">
                          <router-link to="/user/profile/edit?incompleteIndicator=1" class="button sky mr-4" @click.native="$emit('close')">{{ this.$t('modals.profile_update.edit_profile') }}</router-link>
                          <button class="button sky ghost" @click="$emit('close')">{{ this.$t('common.cancel') }}</button>
                        </div>
                      </div>
                    `);
    }

    public showLoginModal() {
        this.showModal(`
                      <div class="p-4">
                        <div class="mb-6 text-center">
                            {{ this.$t('modals.auth.please') }}
                            <router-link tag="a" to="/login" @click.native="$emit('close')">
                                {{ this.$t('modals.auth.sign_in') }}
                            </router-link>
                            {{ this.$t('modals.auth.or') }}
                            <router-link tag="a" to="/register" @click.native="$emit('close')">
                                {{ this.$t('modals.auth.register') }}
                            </router-link>
                            {{ this.$t('modals.auth.first') }}.
                        </div>
                        <div class="flex justify-center">
                            <button class="button sky ghost" @click="$emit('close')">
                                {{ this.$t('common.cancel') }}
                            </button>
                        </div>
                      </div>
                    `);
    }

    public showConfirmationModal(title: string, text: string, confirmed: any = null, confirmLabel: string = null, cancelLabel: string = null) {
        this.showDialog(title, text, [
            {
                title: confirmLabel || this.$t('common.confirm').toString(),
                class: 'vue-dialog-button danger',
                handler: () => {
                    this.$modal.hide('dialog');
                    if (confirmed) {
                        this.$nextTick(() => confirmed());
                    }
                },
            },
            {
                title: cancelLabel || this.$t('common.cancel').toString(),
            },
        ]);
    }

    public showInfoModal(title: string, text: string, button: string = null) {
        this.showDialog(title, text, [
            {
                class: 'vue-dialog-button danger',
                title: button || this.$t('common.close').toString(),
            },
        ]);
    }

    protected showDialog(title: string, text: string, buttons: any) {
        this.$modal.show(
            'dialog',
            {
                title,
                text,
                buttons,
            },
            {
                width: this.modalWidth,
                height: 'auto',
            },
        );
    }

    protected showModal(template: string) {
        this.$modal.show({
                template,
            },
            {
                adaptive: true,
                class: 'w-full',
            },
            {
                width: this.modalWidth,
                height: 'auto',
            });
    }
}
